/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Contract.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import Address from './Address/view.js'
import Body from 'DesignSystem/Body/view.js'
import Checkbox from 'DesignSystem/Checkbox/logic.js'
import FirstName from './FirstName/view.js'
import Info from 'DesignSystem/Info/view.js'
import LastName from './LastName/view.js'
import LegalName from './LegalName/view.js'
import React from 'react'
import SectionContract from 'DesignSystem/SectionContract/view.js'
import Title from 'DesignSystem/Title/view.js'
import TodaysDate from './TodaysDate/logic.js'
import { css } from "emotion"
Checkbox.displayName = 'CheckboxLogic'
TodaysDate.displayName = 'TodaysDateLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
overflowY: "auto",
marginTop: 20,
paddingLeft: 50,
paddingRight: 50,
paddingBottom: 50})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
alignItems: "baseline",
flexWrap: "wrap"})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
height: 2,
width: "100%",
alignSelf: "center",
backgroundColor: "#e6e6e6",
marginTop: 200})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row",
alignItems: "baseline",
marginTop: 20,
flexWrap: "wrap"})
styles.Vertical1 = css({label: 'Vertical1',
  marginLeft: 40,
marginTop: 4})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row",
alignItems: "baseline",
marginTop: 4})
styles.Vertical2 = css({label: 'Vertical2',
  marginTop: 30,
paddingTop: 16,
paddingBottom: 16,
paddingLeft: 50,
paddingRight: 16,
borderBottomLeftRadius: 8,
borderBottomRightRadius: 8,
borderTopLeftRadius: 8,
borderTopRightRadius: 8,
borderColor: "rgba(255,131,0,0.5)",
borderStyle: "solid",
borderWidth: 3})

export default function Contract({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  onChange,
value,
viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
}) {
    
    
    
    
    let data = fromData.useData({ viewPath, path: 'signature.company.has_accepted_agreement', 
context: 'signature',
})
    

  return (<React.Fragment
>
<div
 data-testid="Contract.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
 className={`views-block ${styles.Vertical}`}
>
<Title
 data-testid="Contract.Title"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="DENTAL NETWORK AGREEMENT"
/>
<div
 data-testid="Contract.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
 className={`views-block ${styles.Horizontal}`}
>
<Body
 data-testid="Contract.Body"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={20}
 text="THIS AGREEMENT is made and entered into on"
 marginRight={4}
/>
<TodaysDate
 data-testid="Contract.TodaysDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/TodaysDate`}
/>
<Body
 data-testid="Contract.Body:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 text="by and between"
 marginRight={4}
/>
<LegalName
 data-testid="Contract.LegalName"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/LegalName`}
/>
<Body
 data-testid="Contract.Body:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={4}
 marginRight={4}
 text="(the “Provider”)"
/>
<Body
 data-testid="Contract.Body:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginRight={4}
 text="and Greyfinch,"
/>
<Body
 data-testid="Contract.Body:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={20}
 marginRight={4}
 text="LLC (“Greyfinch”)"
/>
<Body
 data-testid="Contract.Body:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={20}
 marginRight={4}
 text="(Provider and Greyfinch hereinafter"
/>
<Body
 data-testid="Contract.Body:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={20}
 text="referred to as the “Parties”)."
/>
</div>
<SectionContract
 data-testid="Contract.SectionContract"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 marginTop={40}
 number="A."
 body="Greyfinch offers a Direct Dental Care program which provides its Members (as defined herein) with access to Providers that provide Dental Services (as defined herein) on a discounted fee for service basis; and"
/>
<SectionContract
 data-testid="Contract.SectionContract:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="Provider is a licensed provider of dental services in the state of Arkansas; and"
/>
<SectionContract
 data-testid="Contract.SectionContract:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="The Parties desire to enter into an agreement pursuant to which Provider will provide the Dental Services to Members in accordance with the terms and conditions of this Agreement."
/>
<Body
 data-testid="Contract.Body:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={20}
 text="NOW, THEREFORE, for and in consideration of the mutual covenants and conditions referenced and exchanged herein, the sufficiency and receipt of which are hereby acknowledged, the Parties hereto, intending to be legally bound hereby, covenant and agree as follows:"
/>
<Title
 data-testid="Contract.Title:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE I - DEFINITIONS"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 title="Dental Services:"
 body="Refers to any dental care services rendered by a Provider for a Member."
/>
<SectionContract
 data-testid="Contract.SectionContract:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 title="Direct Dental Care Plan"
 body="A membership plan offered by Greyfinch whereby the Provider renders Dental Services, then charges and collects from the Member, as payment in full, no more than the amount set forth on the Fee Schedule."
/>
<SectionContract
 data-testid="Contract.SectionContract:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 title="Fee Schedule"
 body="The schedule of procedures and applicable fees defined in the Greyfinch software, may be amended from time to time by Greyfinch, in its sole discretion.  The Fee Schedule is subject to amendment based on review by and considering utilization patterns, inflation, changes in benefit, etc."
/>
<SectionContract
 data-testid="Contract.SectionContract:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 title="Member"
 body="An individual and their eligible dependents, enrolled in a Direct Dental Care Plan."
/>
<SectionContract
 data-testid="Contract.SectionContract:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 title="Provider"
 body="An individual, partnership, professional corporation, or professional limited liability company, or their agents and employees who are lawfully licensed under the laws of the state where the Dental Services are rendered and who shall provide professional Dental Services to Members at their respective offices, under the terms of this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 title="Provider Network"
 body="The doctors, other health care providers, and hospitals that Greyfinch has contracted with to provide dental care to its Members."
/>
<SectionContract
 data-testid="Contract.SectionContract:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 title="Term"
 body="The Term of this Agreement shall run a minimum of a full calendar year.  If a Provider executes this Agreement in August, the term shall run through December 31 of the following year and be renewed for a one-year term as of January 1 of the next year."
/>
<Title
 data-testid="Contract.Title:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE II - PROVIDER RESPONSIBILITIES, OBLIGATIONS, DUTIES and WARRANTIES"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:10"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="Provider agrees to; (A) accept as payment in full, for Dental Services rendered to Members, the lower of (i) Fee Schedule fees or, (ii) Minimum Discount. Provider further agrees to accept as payment in full for Dental Services rendered to Members, Provider’s usual fee minus the percent identified in benefit for which the Member is enrolled, for any procedure not specifically listed on the Fee Schedule. The discounts will also apply to all Dental Services not covered by insurance for those Members with insurance, (B) accept as payment in full, for Dental Services rendered to Payor Members, according to Payor processing policies, the lower of (i) Fee Schedule fees or, (ii) Minimum Discount. Provider further agrees to accept as payment in full for Dental Services rendered to Members, Provider’s usual fee minus the percent discount defined in the Fee Schedule under the description All Other Procedures Not Listed, for any procedure not specifically listed on the Fee Schedule.  Separate from payment for Dental Services, Provider may receive additional amounts from Greyfinch related to additional non-dental services provided by Provider as outlined in Article III (B)."
/>
<SectionContract
 data-testid="Contract.SectionContract:11"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="Provider is permitted and encouraged to solicit enrollment in the Greyfinch Direct Dental Care Plan. Acceptance or rejection of any application submitted by an individual or entity solicited by Provider is solely the determination of Greyfinch, and no cause need be justified concerning the rejection of any application. Greyfinch makes no covenant or representation whatsoever concerning the acceptance of any Direct Dental Care Plan application."
/>
<SectionContract
 data-testid="Contract.SectionContract:12"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="Provider shall not have authority or right to vary, discharge, waive or modify the terms of membership, promotional brochures, advertising and other materials."
/>
<SectionContract
 data-testid="Contract.SectionContract:13"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="Provider hereby agrees to provide professional Dental Services to Members which shall be identical in all respects to those services rendered to non-members, and which are in accordance with all applicable laws and generally accepted and customary professional and ethical standards."
/>
<SectionContract
 data-testid="Contract.SectionContract:14"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="Provider shall provide all services, equipment, supplies, staff, billing, and collection procedures necessary to provide Dental Services to Members. Provider shall be solely responsible for all taxes, licenses, permits, reports, insurance, bonds, and any other documents or actions necessary to comply with any and all applicable law."
/>
<SectionContract
 data-testid="Contract.SectionContract:15"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="Provider agrees to defend, indemnify and hold Greyfinch harmless from and against any claim, lawsuit, liability, damages, judgment and cost of litigation including attorney’s fees arising out of such provider’s negligence, malpractice, errors or omissions in providing Dental Services and/or products to Members and Payor Members."
/>
<SectionContract
 data-testid="Contract.SectionContract:16"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="G."
 body="Provider shall maintain a valid current policy of professional liability insurance with limits of $1,000,000 single and $3,000,000 in the aggregate during the entire term of the Agreement. Provider agrees to give a minimum of 30 days’ notice of any impending material change, cancellation, or modification in insurance coverage to Greyfinch."
/>
<SectionContract
 data-testid="Contract.SectionContract:17"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="H."
 body="Provider represents and warrants that they are licensed to practice dentistry pursuant to the laws where they are a practicing dentist and agrees to immediately provide written notification to Greyfinch should the holder of such license or registration have such revoked, restricted, suspended or otherwise subject to disciplinary action by any board or government agency."
/>
<SectionContract
 data-testid="Contract.SectionContract:18"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="I."
 body="Provider agrees to maintain all professional and regulatory licenses and certifications required to render service to Members, and shall give a minimum of 30 days’ notice of any impending material change, cancellation, or modification in licensure or certification standing to Greyfinch."
/>
<SectionContract
 data-testid="Contract.SectionContract:19"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="J."
 body="Provider agrees that this Agreement shall not render the Provider as an employee, partner, agent of or joint venturer with Greyfinch, for any purpose. The Parties agree that Provider is an independent contractor and as such, is solely responsible for his/her acts and omissions and the consequences thereof, and is fully able and capable of assessing any risks involved in undertaking the obligations required by this Agreement.  Accordingly, Provider assumes all risks of performing its obligations under this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:20"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="K."
 body="Provider agrees not to use or disclose the identity of Members, or any other confidential information which Provider has received or acquired as a result of this Agreement, nor solicit, divert, or assist any other person or entity in soliciting or diverting any Member to leave Greyfinch’s Direct Dental Care Plan program."
/>
<SectionContract
 data-testid="Contract.SectionContract:21"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="K."
 body="Provider agrees not to use or disclose the identity of Members, or any other confidential information which Provider has received or acquired as a result of this Agreement, nor solicit, divert, or assist any other person or entity in soliciting or diverting any Member to leave Greyfinch’s Direct Dental Care Plan program."
/>
<SectionContract
 data-testid="Contract.SectionContract:22"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="L."
 body="Provider agrees to allow Greyfinch to place on its website and to otherwise publish Provider practice information to allow for consumer search of Provider names, locations and practice areas."
/>
<SectionContract
 data-testid="Contract.SectionContract:23"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="M."
 body="Provider agrees to submit practice information and a copy of their usual and customary fees with this Agreement, and will submit to Greyfinch any practice information or fee changes, within thirty (30) days of any such changes."
/>
<SectionContract
 data-testid="Contract.SectionContract:24"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="N."
 body="Provider agrees and acknowledges that Greyfinch will use a software system to manage the Direct Dental Care Plan."
/>
<SectionContract
 data-testid="Contract.SectionContract:25"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="O."
 body="Provider agrees to offer payment options or patient financing to Payor Members.  By way of example, if a Payor Member needs a crown and cannot pay in full at the time the Dental Services are performed, Provider shall offer an alternative for financing the Dental Services."
/>
<SectionContract
 data-testid="Contract.SectionContract:26"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="P."
 body="Provider agrees and acknowledges that the Direct Dental Care Plan is in no way affiliated with Medicaid and agrees that Provider cannot bill Medicaid for any services provided to a Member of the Direct Dental Care Plan."
/>
<Title
 data-testid="Contract.Title:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE III - GREYFINCH RESPONSIBILITIES, OBLIGATIONS AND DUTIES"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:27"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="Greyfinch will maintain a current list of active and eligible Members in its software which enables Provider to identify active and eligible Members. Greyfinch agrees that Provider shall have the right to require Members to provide personal information to confirm eligibility prior to performing Dental Services; and the right to contact Greyfinch to confirm eligibility."
/>
<SectionContract
 data-testid="Contract.SectionContract:28"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="Greyfinch agrees to pay Provider a portion of membership fees received each month for each Member that has designated Provider as their Primary Care Provider, in compliance with all applicable state and federal laws. Greyfinch offers two Direct Dental Care Plans, Basic and Enhanced, and monthly payment will be made to Provider based on the membership fees for each plan. The payment amount for each plan shall be determined by taking fifty-five percent (55%) of the membership fees for all Members enrolled in each plan, divided by the total number of those enrolled Members, multiplied by the number of Members that assigned Provider as their Primary Care Provider for that plan as of the first of each month."
/>
<Body
 data-testid="Contract.Body:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={20}
 marginLeft={20}
 text="By way of example only, if on January 1 there are 1,000 total Members enrolled in the Basic plan for a total of $15,000 in membership fees for the month of January and 10 of those Members assigned Provider ABC as their Primary Care Provider in the Greyfinch software, then the Basic plan Provider payout for January is $82.50 ($15,000 x 55% / 1,000 x 10)."
/>
<Body
 data-testid="Contract.Body:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={20}
 marginLeft={20}
 text="If a Member terminates coverage before selecting a Primary Care Provider, any unpaid fees will be allocated to the Provider bonus pool."
/>
<SectionContract
 data-testid="Contract.SectionContract:29"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="As allowed by applicable state and federal law, ten percent (10%) of all Greyfinch Direct Dental Care membership fees will be directed each month to a bonus pool to be paid out annually on a pro rata basis to Provider for furnishing a quarterly Member utilization report to Greyfinch. The template and reporting process will be provided by Greyfinch. The payment amount shall be determined by taking the Provider’s production for Members for the year (excluding membership fees and prepaid procedures) as a percent of the total amount of production for Members reported among all participating Greyfinch Providers (production means the procedure cost as defined in the Greyfinch fee schedule). Provider must submit utilization reports timely, as the due dates are defined in the Greyfinch software. Bonus payouts will be made as soon as administratively possible at the beginning of the year for the prior year."
/>
<Body
 data-testid="Contract.Body:10"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={20}
 marginLeft={20}
 text="By way of example only: For 2019, the total Greyfinch Direct Dental Care bonus pool is $30,000 (10% of $300,000 total membership fees). Provider ABC submits utilization reports all twelve months in a timely manner totaling $50,000 in production for the year. The total amount of production reported for the year among all providers is $400,000. In this case Provider ABC accounted for 12.5% of all reported production. Provider ABC will receive $3,750."
/>
<SectionContract
 data-testid="Contract.SectionContract:30"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="Greyfinch agrees to defend, indemnify and hold Provider harmless from and against any claim, lawsuit, liability, damages, judgment and cost of litigation including attorney’s fees arising out of acts of Greyfinch, except to the extent that Provider’s insurer provides insurance coverage for the act or omission complained of."
/>
<SectionContract
 data-testid="Contract.SectionContract:31"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="Greyfinch agrees not to disclose the other Provider’s confidential information without written consent, except as necessary to employees, agents, advisors, participating Payors, or to legal or regulatory agencies as may be required by law. Greyfinch may use Provider’s identifying information, including the names of its dentists and staff, in marketing materials and in its internet provider search."
/>
<SectionContract
 data-testid="Contract.SectionContract:32"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="Greyfinch will not interfere with the Provider/Member (Dentist/Patient) relationship.  Provider shall be the sole provider of Dental Services."
/>
<Title
 data-testid="Contract.Title:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE IV - TERMS OF AGREEMENT"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:33"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="This Agreement shall begin on the date designated above and shall remain in effect for the Term, subject to cancellation by either party without cause upon thirty (30) days’ written notice to the other party."
/>
<SectionContract
 data-testid="Contract.SectionContract:34"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="This Agreement may also be immediately terminated by Greyfinch, without notice, upon the violation of any of the terms of this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:35"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="This Agreement may not be modified, amended, or changed without the prior written consent of all Parties hereto. If any court determines that any portion of this Agreement is unenforceable, it shall be deleted from this Agreement and the Agreement shall otherwise remain in effect. In the event that any change in legislation, statute, law, policy, regulation, policy or legal judgment may make any part of this Agreement unlawful, the Parties shall use their best efforts to make this Agreement comport with the law while maintaining the economic position of the Parties prior thereto."
/>
<SectionContract
 data-testid="Contract.SectionContract:36"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="This Agreement represents the entire agreement of the Parties with respect to the transactions contemplated herein, and any prior or contemporaneous oral or written negotiations, representations or agreements of the Parties are merged herein and may not be used to vary or contradict the terms and provisions hereof."
/>
<SectionContract
 data-testid="Contract.SectionContract:37"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="This Agreement shall inure to the benefit of the Parties and their successors and heirs, but may not be assigned by Provider in whole or in part without the express, written authorization of Greyfinch."
/>
<SectionContract
 data-testid="Contract.SectionContract:38"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="This Agreement shall be subject to and governed by the laws of the State of Arkansas."
/>
<SectionContract
 data-testid="Contract.SectionContract:39"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="G."
 body="Each of the undersigned expressly warrants his or her authority to enter into and execute this Agreement on behalf of the respective Party."
/>
<SectionContract
 data-testid="Contract.SectionContract:40"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="H."
 body="This Agreement may be executed in counterparts and, if so executed, each executed counterpart shall be deemed an original."
/>
<Body
 data-testid="Contract.Body:11"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={50}
 text="IN WITNESS WHEREOF, the Parties hereunto have affixed their signatures and seals on the day first written above."
/>
<div
 data-testid="Contract.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
 className={`views-block ${styles.Horizontal1}`}
/>
<Title
 data-testid="Contract.Title:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="BUSINESS ASSOCIATE AGREEMENT"
 marginTop={200}
/>
<div
 data-testid="Contract.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
 className={`views-block ${styles.Horizontal2}`}
>
<Body
 data-testid="Contract.Body:12"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="This Business Associate Agreement"
/>
<Body
 data-testid="Contract.Body:13"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="(the “Agreement”), is made as of"
/>
<TodaysDate
 data-testid="Contract.TodaysDate:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/TodaysDate`}
/>
<Body
 data-testid="Contract.Body:14"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="(the “Effective Date”),"
/>
<Body
 data-testid="Contract.Body:15"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="by and between"
/>
<LegalName
 data-testid="Contract.LegalName:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/LegalName`}
/>
<Body
 data-testid="Contract.Body:16"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginLeft={4}
 marginRight={4}
 text="(“Covered Entity”) and Greyfinch,"
/>
<Body
 data-testid="Contract.Body:17"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="LLC (collectively"
/>
<Body
 data-testid="Contract.Body:18"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="“Business Associate”)"
/>
<Body
 data-testid="Contract.Body:19"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="to comply with privacy"
/>
<Body
 data-testid="Contract.Body:20"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="standards adopted"
/>
<Body
 data-testid="Contract.Body:21"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="by the U.S. Department"
/>
<Body
 data-testid="Contract.Body:22"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="of Health and Human"
/>
<Body
 data-testid="Contract.Body:23"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="Services as they"
/>
<Body
 data-testid="Contract.Body:24"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="may be amended from time to time, 45 C.F.R. parts 160 and 164 (“the Privacy Rule”) and security standards adopted by the U.S. Department of Health and Human Services as they may be amended from time to time, 45 C.F.R. parts 160, 162 and 164, subpart C (“the Security Rule”), and the Health Information Technology for Economic and Clinical Health (HITECH) Act, Title XIII of Division A and Title IV of Division B of the American Recovery and Reinvestment Act of 2009 and regulations promulgated there under and any applicable state confidentiality laws.  Business Associate and Covered Entity are collectively referred to herein as the “Parties.”"
/>
</div>
<Title
 data-testid="Contract.Title:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="RECITALS"
 marginTop={30}
/>
<SectionContract
 data-testid="Contract.SectionContract:41"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="WHEREAS,"
 body="the Business Associate provides Direct Dental Care benefits software and administrative services, and in connection with those services, Business Associate may use or disclose certain individual health information that is subject to protection under the Health Insurance Portability and Accountability Act of 1996, as amended (“HIPAA”), the Privacy Rule, and the Security Rule; and"
/>
<SectionContract
 data-testid="Contract.SectionContract:42"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="WHEREAS,"
 body="the Parties wish to comply with the requirements of: (i) the implementing regulations at 45 C.F.R Parts 160, 162 and 164 (i.e., the HIPAA Privacy, Security, Electronic Transactions, Breach Notification, and Enforcement Rules (“the implementing Regulations”)), (ii) the requirements of the Health Information Technology for Economic and Clinical Health Act, as incorporated in the American Recovery and Reinvestment Act of 2009 (“the HITECH Act”) that are applicable to business associates, and (iii) the requirements of the final modifications to the HIPAA Privacy, Security, Enforcement and Breach Notification Rules as issued on January 25, 2013, and effective [MONTH] 26, 2013 (75 Fed. Reg. 5566 (Jan. 25, 2013)) (“the Final Regulations”)."
/>
<SectionContract
 data-testid="Contract.SectionContract:43"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="NOW THEREFORE,"
 body="in consideration of the mutual covenants and conditions contained herein and other good and valuable consideration, the receipt and sufficiency of which is hereby acknowledged, the Parties agree as follows:"
/>
<Title
 data-testid="Contract.Title:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE I DEFINITIONS"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:44"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1.1."
 title="HIPAA Rules Definitions"
 body="The following terms used in this Agreement shall have the same meaning as those terms in the HIPAA Rules: Data Aggregation, Disclosure, Health Care Operations, Individual, Minimum Necessary, Notice of Privacy Practices, Protected Health Information, Required by Law, Secretary, Security Incident, Subcontractor, and Use."
/>
<SectionContract
 data-testid="Contract.SectionContract:45"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1.2."
 title="Additional Definitions"
 body="The following terms used in this Agreement shall have the meanings provided below."
/>
<SectionContract
 data-testid="Contract.SectionContract:46"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="“Breach” shall mean the unauthorized acquisition, access, use, or disclosure of PHI which compromises the security or privacy of such information, except where an unauthorized person to whom such information is disclosed would not reasonably have been able to retain such information."
/>
<SectionContract
 data-testid="Contract.SectionContract:47"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="“Business Associate” shall generally have the same meaning as the term “business associate” at 45 CFR 160.103."
/>
<SectionContract
 data-testid="Contract.SectionContract:48"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="“Covered Entity” shall generally have the same meaning as the term “covered entity” at 45 CFR 160.103."
/>
<SectionContract
 data-testid="Contract.SectionContract:49"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="“Designated Record Set” shall mean a group of records maintained by or for a Covered Entity that is:  (i) the medical records and billing records about Individuals maintained by or for a covered health care provider; (ii) the enrollment, payment, claims adjudication, and case or medical management record systems maintained by or for a health plan; or (iii) used, in whole or in part, by or for the covered entity to make decisions about Individuals.  For purposes of this definition, the term “record” means any item, collection, or grouping of information that includes PHI and is maintained, collected, used, or disseminated by or for a covered entity."
/>
<SectionContract
 data-testid="Contract.SectionContract:50"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="The Privacy Rule and the Security Rule and amendments codified and promulgated by the HITECH Act are referred to collectively herein as “HIPAA Rules.”"
/>
<SectionContract
 data-testid="Contract.SectionContract:51"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="“Protected Health Information” or PHI shall mean individually identifiable health information that is transmitted or maintained in any form or medium."
/>
<Title
 data-testid="Contract.Title:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE II PERMITTED USES"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:52"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="2.1."
 title="Permitted Uses and Disclosures by Business Associate"
 body="Except as otherwise limited in this Agreement, Business Associate may use or disclose Protected Health Information to perform functions, activities, or services for, or on behalf of, Covered Entity as specified in this Agreement (the “Services”), provided that such use or disclosure would not violate the HIPAA Rules if done by Covered Entity or the minimum necessary policies and procedures of the Covered Entity.  Also, Business Associate may use PHI to report violations of law to appropriate Federal and State authorities, consistent with the HIPAA Rules."
/>
<SectionContract
 data-testid="Contract.SectionContract:53"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 title="Use"
 body="Business Associate will not, and will ensure that its directors, officers, employees, contractors, and other agents do not, use PHI other than as permitted or required by Business Associate to perform the Services or as required by law, but in no event in any manner that would constitute a violation of the Privacy Standards or Security Standards if used by Covered Entity."
/>
<SectionContract
 data-testid="Contract.SectionContract:54"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 title="Disclosure"
 body="Business Associate will not, and will ensure that its directors, officers, employees, contractors, and other agents do not, disclose PHI other than as permitted pursuant to this Agreement or as required by law, but in no event disclose PHI in any manner that would constitute a violation of the Privacy Standards or Security Standards if disclosed by Covered Entity."
/>
<SectionContract
 data-testid="Contract.SectionContract:55"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 title="Data Aggregation"
 body="In the event that Business Associate works for more than one Covered Entity, Business Associate is permitted to use and disclose PHI for data aggregation purposes, however, only in order to analyze data for permitted health care operations, and only to the extent that such use is permitted under HIPAA Rules."
/>
<SectionContract
 data-testid="Contract.SectionContract:56"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 title="De-identified Information"
 body="Business Associate may use and disclose de-identified health information if the PHI is de-identified in compliance with the HIPAA Rules."
/>
<Title
 data-testid="Contract.Title:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE III OBLIGATIONS OF COVERED ENTITY"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:57"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="3.1."
 title="Obligations of Covered Entity"
 body="If applicable, Covered Entity shall:"
/>
<SectionContract
 data-testid="Contract.SectionContract:58"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="provide Business Associate a copy of its Notice of Privacy Practices (“Notice”) produced by Covered Entity in accordance with 45 C.F.R. 164.520 as well as any changes to such Notice;"
/>
<SectionContract
 data-testid="Contract.SectionContract:59"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="provide Business Associate with any changes in, or revocation of, authorizations by Individuals relating to the use and/or disclosure of PHI, if such changes affect Business Associate’s permitted or required uses and/or disclosures;"
/>
<SectionContract
 data-testid="Contract.SectionContract:60"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="notify Business Associate of any restriction to the use and/or disclosure of PHI to which Covered Entity has agreed in accordance with 45 C.F.R. 164.522, to the extent that such restriction may affect Business Associate’s use or disclosure of PHI;"
/>
<SectionContract
 data-testid="Contract.SectionContract:61"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="not request Business Associate to use or disclose PHI in any manner that would not be permissible under the Privacy Rule if done by the Covered Entity;"
/>
<SectionContract
 data-testid="Contract.SectionContract:62"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="notify Business Associate of any amendment to PHI to which Covered Entity has agreed that affects a Designated Record Set maintained by Business Associate;"
/>
<SectionContract
 data-testid="Contract.SectionContract:63"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="if Business Associate maintains a Designated Record Set, provide Business Associate with a copy of its policies and procedures related to an Individual’s right to: access PHI; request an amendment to PHI; request confidential communications of PHI; or request an accounting of disclosures of PHI; and"
/>
<SectionContract
 data-testid="Contract.SectionContract:64"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="G."
 body="notify Individuals of any Breach Required by Law."
/>
<Title
 data-testid="Contract.Title:10"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE IV OBLIGATIONS OF BUSINESS ASSOCIATE"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:65"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="4.1."
 title="Obligations of Business Associate"
 body="Business Associate agrees to comply with applicable federal and state confidentiality and security laws, specifically the provisions of the HIPAA Rules applicable to business associates.  Additionally, when applicable, Business Associate shall:"
/>
<SectionContract
 data-testid="Contract.SectionContract:66"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="not use or further disclose Protected Health Information other than as permitted or required by this Agreement or as Required by Law."
/>
<SectionContract
 data-testid="Contract.SectionContract:67"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="provide information and training to members of its workforce using or disclosing PHI regarding the confidentiality requirements of the HIPAA Rules and this Agreement;"
/>
<SectionContract
 data-testid="Contract.SectionContract:68"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="obtain reasonable assurances from the person or entity to whom the PHI is disclosed that: (a) the PHI will be held confidential and further used and disclosed only as required by law or for the purpose for which it was disclosed to the person or entity; and (b) the person or entity will notify Business Associate of any instances of which it is aware in which confidentiality of the PHI has been breached;"
/>
<SectionContract
 data-testid="Contract.SectionContract:69"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="mitigate, to the extent practicable, any harmful effect that is known to the Business Associate of a use or disclosure of PHI by the Business Associate in violation of the requirements of the Agreement"
/>
<SectionContract
 data-testid="Contract.SectionContract:70"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="notify the designated Privacy Officer of Covered Entity of any instances of which it is aware in which the PHI is used or disclosed for a purpose that is not otherwise provided for in this Agreement or for a purpose not expressly permitted by the HIPAA Rules;"
/>
<SectionContract
 data-testid="Contract.SectionContract:71"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="Business Associate shall maintain appropriate safeguards to ensure that PHI is not used or disclosed other than as provided by this Agreement or as required by law.  Business Associate shall implement administrative, physical and technical safeguards that reasonably and appropriately protect the confidentiality, integrity, and availability of any paper or electronic PHI it creates, receives, maintains, or transmits on behalf of Covered Entity;"
/>
<SectionContract
 data-testid="Contract.SectionContract:72"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="i."
 body="Implement policies and procedures to prevent, detect, contain, and correct security violations;"
/>
<SectionContract
 data-testid="Contract.SectionContract:73"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="ii."
 body="Implement policies and procedures to limit physical access to its electronic information systems and the facility or facilities in which they are housed, while ensuring that properly authorized access is allowed;"
/>
<SectionContract
 data-testid="Contract.SectionContract:74"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="iii."
 body="Implement technical policies and procedures for electronic information systems that maintain electronic protected health information to allow access only to those persons or software programs that have been granted access rights; and"
/>
<SectionContract
 data-testid="Contract.SectionContract:75"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="iv."
 body="Implement reasonable written policies and procedures to comply with the standards, implementation specifications, or other requirements of the policies listed above."
/>
<SectionContract
 data-testid="Contract.SectionContract:76"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="G."
 body="Business Associate shall assure that all PHI is secured when accessed by Business Associate’s employees, agents, or subcontractor.  Any access to PHI by Business Associate’s employees, agents or subcontractors shall be limited to legitimate business needs while working with PHI;"
/>
<SectionContract
 data-testid="Contract.SectionContract:77"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="H."
 body="Business Associate shall ensure that all uses and disclosures of PHI are subject to the principle of “minimum necessary use and disclosure,” i.e., that only PHI that is the minimum necessary to accomplish the intended purpose of the use, disclosure, or request is used or disclosed; and, the use of limited data sets when possible;"
/>
<SectionContract
 data-testid="Contract.SectionContract:78"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="I."
 body="If Business Associate discloses PHI received from Covered Entity, or created or received by Business Associate on behalf of Covered Entity, to agents, including a subcontractor, Business Associate shall require the agent or subcontractor to agree to the same restrictions and conditions as apply to Business Associate under this Agreement.  Business Associate agrees that, as required by HIPAA, Business Associate will enter into a written agreement with all subcontractors that: (i) requires them to comply with the Privacy and Security Rule provisions of this Agreement in the same manner as required of Business Associate, and (ii) notifies such subcontractors that they will incur liability under the HIPAA Requirements for non-compliance with such provisions. Accordingly, Business Associate shall ensure that all subcontractors agree in writing to the same privacy and security restrictions, conditions and requirements that apply to Business Associate with respect to PHI. Business Associate shall ensure that any agent, including a subcontractor, agrees to implement reasonable and appropriate safeguards to protect the confidentiality, integrity, and availability of the paper or electronic PHI that it creates, receives, maintains, or transmits on behalf of the Covered Entity;"
/>
<SectionContract
 data-testid="Contract.SectionContract:79"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="J."
 body="Except as otherwise specified herein, Business Associate shall make available its internal practices, books, and records relating to the use and disclosure of PHI, received from, or created or received on behalf of by Business Associate, Covered Entity to the Secretary or his or her agents for the purpose of determining Covered Entity’s compliance with the HIPAA Rules, or any other health oversight agency, or to Covered Entity;"
/>
<SectionContract
 data-testid="Contract.SectionContract:80"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="K."
 body="Business Associate shall abide by the limitations of Covered Entity’s Notice of which it has knowledge. Any use or disclosure permitted by this Agreement may be amended by changes to Covered Entity’s Notice; provided, however, that the amended Notice shall not affect permitted uses and disclosures on which Business Associate relied prior to receiving notice of such amended Notice;"
/>
<SectionContract
 data-testid="Contract.SectionContract:81"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="L."
 body="Business Associate expressly recognizes that Covered Entity has certain reporting and disclosure obligations to the Secretary and the Individual in case of a security breach of unsecured PHI.  Where Business Associate accesses, maintains, retains, modifies, records, stores, destroys, or otherwise holds, uses or discloses unsecured paper or electronic PHI, Business Associate, immediately following the discovery of a breach of such information, shall notify Covered Entity of such breach.  Initial notification of the breach does not need to be in compliance with Sub Title D Title IV Section 13402 of the HITECH Act; however, Business Associate must provide Covered Entity with all information necessary for Covered Entity to comply with Sub Title D Title IV Section 13402 of the HITECH Act without reasonable delay, and in no case later than thirty (30) days following the discovery of the Breach."
/>
<SectionContract
 data-testid="Contract.SectionContract:82"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="M."
 body="Business Associate agrees to only use or disclose PHI received by the Business Associate in its capacity as a Business Associate to the Covered Entity for Business Associate’s own operations if:"
/>
<SectionContract
 data-testid="Contract.SectionContract:83"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="i."
 body="the use relates to the proper management and administration of the Business Associate or to carry out legal responsibilities of the Business Associate, or data aggregation services relating to the health care operations of the Covered Entity; or"
/>
<SectionContract
 data-testid="Contract.SectionContract:84"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="ii."
 body="the disclosure of information received in such capacity will be made in connection with a function, responsibility, or services to be performed by the Business Associate, and such disclosure is required by law or the Business Associate obtains reasonable assurances from the person to whom the information is disclosed that it will be held confidential and the person agrees to notify the Business Associate of any breaches of confidentiality."
/>
<SectionContract
 data-testid="Contract.SectionContract:85"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="N."
 body="Business Associate agrees to report to the Covered Entity any use or disclosure of the Protected Health Information not provided for by this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:86"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="O."
 body="Business Associate agrees to report to the Covered Entity as soon as possible any “security incident” of which it becomes aware, as such term is defined in the HIPAA Security Rule."
/>
<Title
 data-testid="Contract.Title:11"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE V INDIVIDUAL RIGHTS"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:87"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="5.1."
 title="Individual Rights Regarding Designated Record Sets"
 body="If Business Associate maintains a Designated Record Set on behalf of Covered Entity, Business Associate agrees as follows:"
/>
<SectionContract
 data-testid="Contract.SectionContract:88"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 title="Individual Right to Copy or Inspection"
 body="Business Associate agrees that if it maintains a Designated Record Set for Covered Entity that is not maintained by Covered Entity, it will permit an Individual to inspect or copy PHI about the Individual in that set as directed by Covered Entity to meet the requirements of 45 C.F.R. § 164.524.  If the PHI is in electronic format, the Individual shall have a right to obtain a copy of such information in electronic format and, if the Individual chooses, to direct that an electronic copy be transmitted directly to an entity or person designated by the individual in accordance with HITECH section 13405(e).  Under the Privacy Rule, Covered Entity is required to take action on such requests as soon as possible, but not later than thirty (30) days following receipt of the request.  Business Associate agrees to make reasonable efforts to assist Covered Entity in meeting this deadline.  The information shall be provided in the form or format requested if it is readily producible in such form or format; or in summary, if the Individual has agreed in advance to accept the information in summary form.  A reasonable, cost-based fee for copying health information may be charged.  If Covered Entity maintains the requested records, Covered Entity, rather than Business Associate shall permit access according to its policies and procedures implementing the Privacy Rule."
/>
<SectionContract
 data-testid="Contract.SectionContract:89"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 title="Individual Right to Amendment"
 body="Business Associate agrees, if it maintains PHI in a Designated Record Set, to make amendments to PHI at the request and direction of Covered Entity pursuant to 45 C.F.R. 164.526.  If Business Associate maintains a record in a Designated Record Set that is not also maintained by Covered Entity, Business Associate agrees that it will accommodate an Individual’s request to amend PHI only in conjunction with a determination by Covered Entity that the amendment is appropriate according to 45 C.F.R. § 164.526."
/>
<SectionContract
 data-testid="Contract.SectionContract:90"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 title="Accounting of Disclosures"
 body="Business Associate agrees to maintain documentation of the information required to provide an accounting of disclosures of PHI, whether PHI is paper or electronic format, in accordance with 45 C.F.R. § 164.528 and HITECH Sub Title D Title VI Section 13405(c), and to make this information available to Covered Entity upon Covered Entity’s request, in order to allow Covered Entity to respond to an Individual’s request for accounting of disclosures.  Under the Privacy Rule, Covered Entity is required to take action on such requests as soon as possible but not later than sixty (60) days following receipt of the request.  Business Associate agrees to use its best efforts to assist Covered Entity in meeting this deadline but not later than forty-five (45) days following receipt of the request.  Such accounting must be provided without cost to the Individual or Covered Entity if it is the first accounting requested by an Individual within any 12 month period; however, a reasonable, cost-based fee may be charged for subsequent accountings if Business Associate informs the individual in advance of the fee and is afforded an opportunity to withdraw or modify the request.  Such accounting is limited to disclosures that were made in the six (6) years prior to the request (not including disclosures prior to the compliance date of the Privacy Rule) and shall be provided for as long as Business Associate maintains the PHI."
/>
<Title
 data-testid="Contract.Title:12"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE VI TERM AND TERMINATION"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:91"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="6.1."
 title="Term"
 body="This Agreement shall be effective as of the Effective Date and shall be terminated when all PHI provided to Business Associate by Covered Entity, or created or received by Business Associate on behalf of Covered Entity, is destroyed or returned to Covered Entity."
/>
<SectionContract
 data-testid="Contract.SectionContract:92"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="6.2."
 title="Termination for Cause"
 body="Upon Covered Entity’s discovery of a material breach by Business Associate, Covered Entity shall either:"
/>
<SectionContract
 data-testid="Contract.SectionContract:93"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="A."
 body="Provide an opportunity for Business Associate to cure the breach or end the violation, and terminate this Agreement if Business Associate does not cure the breach or end the violation within the time specified by Covered Entity; or"
/>
<SectionContract
 data-testid="Contract.SectionContract:94"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="B."
 body="Immediately terminate this Agreement if Business Associate has breached a material term of this Agreement and cure is not possible."
/>
<SectionContract
 data-testid="Contract.SectionContract:95"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="6.3."
 title="Effect of Termination"
 body="Upon termination of this Agreement for any reason, Business Associate agrees to return or destroy all PHI received from Covered Entity, or created or received by Business Associate on behalf of Covered Entity, maintained by Business Associate in any form.  If Business Associate determines that the return or destruction of PHI is not feasible, Business Associate shall inform Covered Entity in writing of the reason thereof, and shall agree to extend the protections of this Agreement to such PHI and limit further uses and disclosures of the PHI to those purposes that make the return or destruction of the PHI not feasible for so long as Business Associate retains the PHI."
/>
<Title
 data-testid="Contract.Title:13"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE VII INDEMNIFICATION AND INSURANCE"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:96"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="7.1."
 title="Indemnification"
 body="Business Associate shall indemnify, defend, and hold Covered Entity, its employees, directors, trustees, officers, representatives and agents (collectively, the “Indemnitees”) harmless from and against all claims, causes of action, liabilities, judgments, fines, assessments, penalties, damages, awards or other expenses, of any kind or nature whatsoever, including, without limitation, attorney’s fees, expert witness fees, and costs of investigation, litigation or dispute resolution, incurred by the Indemnitees and relating to or arising out of any breach or alleged breach of the terms of this Agreement by Business Associate."
/>
<SectionContract
 data-testid="Contract.SectionContract:97"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="7.2."
 title="Insurance"
 body="If Covered Entity requires, Business Associate shall obtain and maintain insurance coverage against improper uses and disclosures of PHI by Business Associate, naming Covered Entity as an additional insured.  Promptly following a request by Covered Entity for the maintenance of such insurance coverage, Business Associate shall provide a certificate evidencing such insurance coverage."
/>
<Title
 data-testid="Contract.Title:14"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE VIII MISCELLANEOUS"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:98"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="8.1."
 title="Additional Terms"
 body="The following terms shall also apply to this Agreement:"
/>
<SectionContract
 data-testid="Contract.SectionContract:99"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="A."
 title="Mitigation"
 body="If Business Associate violates this Agreement or either of the HIPAA Rules, Business Associate agrees to mitigate any damage caused by such breach."
/>
<SectionContract
 data-testid="Contract.SectionContract:100"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="B."
 title="Survival"
 body="The rights and obligations of Business Associate under Section 6.3 of this Agreement shall survive the termination of this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:101"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="C."
 title="Notices"
 body="Any notices pertaining to this Agreement shall be given in writing and shall be deemed duly given when personally delivered to a Party or a Party's authorized representative as listed below or sent by means of a reputable overnight carrier, or sent by means of certified mail, return receipt requested, postage prepaid.  A notice sent by certified mail shall be deemed given on the date of receipt or refusal of receipt.  All notices shall be addressed to the appropriate Party as follows:"
/>
<Body
 data-testid="Contract.Body:25"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 text="If to Business Associate:"
/>
<Body
 data-testid="Contract.Body:26"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 fontWeight={500}
 marginTop={4}
 text="Greyfinch, LLC"
/>
<Body
 data-testid="Contract.Body:27"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 fontWeight={500}
 marginTop={4}
 text="ATTN: Josh Matthews"
/>
<Body
 data-testid="Contract.Body:28"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 fontWeight={500}
 marginTop={4}
 text="610 President Clinton A"
/>
<Body
 data-testid="Contract.Body:29"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 fontWeight={500}
 marginTop={4}
 text="Little Rock, AR 72201"
/>
<Body
 data-testid="Contract.Body:30"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 marginTop={20}
 text="If to Covered Entity:"
/>
<div
 data-testid="Contract.Vertical:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
 className={`views-block ${styles.Vertical1}`}
>
<LegalName
 data-testid="Contract.LegalName:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/LegalName`}
 marginTop={0}
/>
<div
 data-testid="Contract.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
 className={`views-block ${styles.Horizontal3}`}
>
<Body
 data-testid="Contract.Body:31"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 fontWeight={500}
 marginRight={4}
 marginTop={0}
 text="ATTN:"
/>
<FirstName
 data-testid="Contract.FirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/FirstName`}
/>
<Body
 data-testid="Contract.Body:32"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 fontWeight={500}
 marginRight={4}
 marginTop={0}
 text=","
/>
<LastName
 data-testid="Contract.LastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/LastName`}
/>
</div>
<Address
 data-testid="Contract.Address"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Address`}
/>
</div>
<SectionContract
 data-testid="Contract.SectionContract:102"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="D."
 title="Amendment"
 body="This Agreement may not be changed or modified in any manner except by an instrument in writing signed by a duly authorized officer of each of the Parties hereto.  The Parties, however, agree to amend this Agreement from time to time as necessary, in order to allow Covered Entity to comply with the requirements of the HIPAA Rules."
/>
<SectionContract
 data-testid="Contract.SectionContract:103"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="E."
 title="Choice of Law"
 body="This Agreement and the rights and the obligations of the Parties hereunder shall be governed by and construed under the laws of the State of Arkansas without regard to applicable conflict of laws principles."
/>
<SectionContract
 data-testid="Contract.SectionContract:104"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="F."
 title="Assignment"
 body="Except as provided in the next section, neither party shall assign its rights or obligations hereunder without the prior written consent of the other, provided however, that Greyfinch may assign the Agreement to a related entity or to any successor in a corporate reorganization or restructuring, including the purchaser of substantially all of Greyfinch’s assets, without consent."
/>
<SectionContract
 data-testid="Contract.SectionContract:105"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="G."
 title="Nature of Agreement"
 body="Nothing in this Agreement shall be construed to create (i) a partnership, joint venture or other joint business relationship between the Parties or any of their affiliates, (ii) any fiduciary duty owed by one Party to another Party or any of its affiliates, or (iii) a relationship of employer and employee between the Parties."
/>
<SectionContract
 data-testid="Contract.SectionContract:106"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="H."
 title="No Waiver"
 body="Failure or delay on the part of either Party to exercise any right, power, privilege or remedy hereunder shall not constitute a waiver thereof.  No provision of this Agreement may be waived by either Party except by a writing signed by an authorized representative of the Party making the waiver."
/>
<SectionContract
 data-testid="Contract.SectionContract:107"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="I."
 title="Severability"
 body="The provisions of this Agreement shall be severable, and if any provision of this Agreement shall be held or declared to be illegal, invalid or unenforceable, the remainder of this Agreement shall continue in full force and effect as though such illegal, invalid or unenforceable provision had not been contained herein."
/>
<SectionContract
 data-testid="Contract.SectionContract:108"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="J."
 title="No Third-Party Beneficiaries"
 body="Nothing in this Agreement shall be considered or construed as conferring any right or benefit on a person not party to this Agreement nor imposing any obligations on either Party hereto to persons not a party to this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:109"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="K."
 title="Headings"
 body="The descriptive headings of the articles, sections, subsections, exhibits and schedules of this Agreement are inserted for convenience only, do not constitute a part of this Agreement and shall not affect in any way the meaning or interpretation of this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:110"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="L."
 title="Entire Agreement"
 body="AThis Agreement, together with all exhibits, riders and amendments, if applicable, which are fully completed and signed by authorized persons on behalf of both Parties from time-to-time while this Agreement is in effect, constitutes the entire agreement between the Parties hereto with respect to the subject matter hereof and supersedes all previous written or oral understandings, agreements, negotiations, commitments, and any other writing and communication by or between the Parties with respect to the subject matter hereof.  In the event of any inconsistencies between any provisions of this Agreement in any provisions of the exhibits, riders, or amendments, the provisions of this Agreement shall control."
/>
<SectionContract
 data-testid="Contract.SectionContract:111"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="M."
 title="Interpretation"
 body="Any ambiguity in this Agreement shall be resolved in favor of a meaning that permits Covered Entity to comply with the HIPAA Rules and any applicable state confidentiality laws.  The provisions of this Agreement shall prevail over the provisions of any other agreement that exists between the Parties that may conflict with, or appear inconsistent with, any provision of this Agreement or the HIPAA Rules."
/>
<SectionContract
 data-testid="Contract.SectionContract:112"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="N."
 title="Regulatory References"
 body="A citation in this Agreement to the Code of Federal Regulations shall mean the cited section as that section may be amended from time-to-time."
/>
<SectionContract
 data-testid="Contract.SectionContract:113"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="O."
 title="Execution"
 body="This Agreement may be executed in multiple counterparts, each of which shall constitute an original and all of which shall constitute but one agreement."
/>
<Body
 data-testid="Contract.Body:33"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={20}
 text="IN WITNESS WHEREOF, the undersigned have set their hands and signatures as of the day and year first above written."
/>
<div
 data-testid="Contract.Vertical:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
 className={`views-block ${styles.Vertical2}`}
>
<Checkbox
 data-testid="Contract.Checkbox"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Checkbox`}
 onClick={data.onChange}
 isSelected={data.value}
 text="I understand I am signing two agreements:"
 fontSize={16}
/>
<Info
 data-testid="Contract.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Info`}
 marginLeft={35}
 marginTop={8}
 text="1) Greyfinch Direct Dental Care provider agreement"
/>
<Info
 data-testid="Contract.Info:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/ProviderContract/Contract"
viewPath={`${viewPath}/Info`}
 marginLeft={35}
 marginTop={8}
 text="2) Greyfinch business associate agreement"
/>
</div>
</div>
{children}
</React.Fragment>)
}